import { axiosGet,axiosPost } from "../../../react_axios/Axios";
import { getDelegateSeminarDetailsUrl, insertUpdateDelegateSeminarUrl, INSERT_UPDATE_DELEGATE_SEMINAR_ACTION_TYPE, GET_DELEGATE_SEMINAR_ACTION_TYPE, headers } from "../../../utils/constants";


export const getDelegateSeminarDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateRegistrationID: sessionStorage.getItem("DelegateRegistrationID"),
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        }

        const res = await axiosGet(getDelegateSeminarDetailsUrl, params, headers)

        dispatch({
            type: GET_DELEGATE_SEMINAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateDelegateSeminar_action = ( SeminarIDList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateRegistrationID: sessionStorage.getItem("DelegateRegistrationID"),
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            SeminarIDList: SeminarIDList,
        }

        const res = await axiosPost(insertUpdateDelegateSeminarUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_DELEGATE_SEMINAR_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}